module.exports = __webpack_public_path__ + "img/KubePi-assist-red.60b5cf66.png";